import { queryClient } from '@/lib/react-query';
import { post } from '@/utils/api';
import { useMutation } from '@tanstack/react-query';
import { featureKeys, featurePath } from '.';

export const useSnoozeLead = () =>
  useMutation({
    mutationFn: (id: number) => post(`${featurePath}/opportunities/leads/${id}/snooze`, {}),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: featureKeys.all }),
  });

export const useSnoozeCustomer = () =>
  useMutation({
    mutationFn: (id: number) => post(`${featurePath}/opportunities/customers/${id}/snooze`, {}),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: featureKeys.all }),
  });
